import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "rabitsch_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

export const fetchArtist = (slug) => api.get(`/content/${slug}`).then((r) => r.data);
export const updateArtist = (slug, body) => api.put(`/content/${slug}`, body).then((r) => r.data);
export const resetArtist = (slug) => api.post(`/content/reset/${slug}`).then((r) => r.data);
export const login = (email, password) => api.post(`/auth/login`, { email, password }).then((r) => r.data);
export const fetchMe = () => api.get(`/auth/me`).then((r) => r.data);

// Guestbook
export const fetchGuestbookStats = () => api.get(`/guestbook/stats`).then((r) => r.data);
export const fetchGuestbook = (category) =>
    api
        .get(`/guestbook`, { params: category && category !== "all" ? { category } : {} })
        .then((r) => r.data);
export const submitGuestbook = (formData) =>
    api
        .post(`/guestbook`, formData, { headers: { "Content-Type": "multipart/form-data" } })
        .then((r) => r.data);
export const adminFetchGuestbook = () => api.get(`/guestbook/admin/all`).then((r) => r.data);
export const adminSetStatus = (id, status) =>
    api.put(`/guestbook/admin/${id}/status`, { status }).then((r) => r.data);
export const adminDeleteEntry = (id) => api.delete(`/guestbook/admin/${id}`).then((r) => r.data);

export const mediaUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${BACKEND_URL}${path}`;
};
